import { Link } from "react-router-dom";
import Seo from "@/components/feature/Seo";
import Breadcrumbs from "@/components/feature/Breadcrumbs";
import { categories } from "@/mocks/categories";
import { getArticlesByCategory } from "@/mocks/articles";
import { buildBreadcrumbSchema } from "@/lib/seo";
import { tintMap } from "@/lib/content";
import { SITE_URL } from "@/mocks/site";

export default function Topics() {
  const jsonLd = [
    buildBreadcrumbSchema([
      { name: "首页", path: "/" },
      { name: "主题分类", path: "/topics" },
    ]),
    {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      name: "主题分类",
      url: `${SITE_URL}/topics`,
      inLanguage: "zh-CN",
      mainEntity: {
        "@type": "ItemList",
        itemListElement: categories.map((item, index) => ({
          "@type": "ListItem",
          position: index + 1,
          url: `${SITE_URL}/topic/${item.slug}`,
          name: item.name,
        })),
      },
    },
  ];

  return (
    <>
      <Seo
        title="主题分类 - 黑料看点综艺影视网络热点分类导航"
        description="黑料看点主题分类导航，按综艺看点、影视热剧、网络热点、明星动态、现场直击与深度观察六个方向整理内容，方便你长期追踪某一类看点。"
        keywords="黑料看点分类,综艺看点,影视热剧,网络热点,明星动态"
        path="/topics"
        jsonLd={jsonLd}
      />

      <section className="bg-background-50 border-b border-background-200">
        <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6 pt-6 pb-8 md:pt-8 md:pb-10">
          <Breadcrumbs items={[{ name: "主题分类" }]} />
          <h1 className="mt-6 font-heading text-3xl md:text-4xl text-foreground-950">主题分类</h1>
          <p className="mt-3 max-w-2xl text-sm md:text-base leading-relaxed text-foreground-600">
            六个长期维护的内容方向。每个分类下都是同主题的持续沉淀，适合你想专心追某一类看点时逐条细看。
          </p>
        </div>
      </section>

      <section className="bg-background-50">
        <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6 py-12 md:py-16">
          <div className="flex flex-col gap-6 md:gap-8">
            {categories.map((item, index) => {
              const tint = tintMap[item.tint];
              const list = getArticlesByCategory(item.slug);
              return (
                <article
                  key={item.slug}
                  className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10 p-6 md:p-8 rounded-lg bg-background-100 border border-background-200"
                >
                  <div className="lg:col-span-4">
                    <div className="flex items-center gap-3">
                      <span className={`w-12 h-12 flex items-center justify-center rounded-md ${tint.chipBg} ${tint.chipText}`}>
                        <i className={`${item.icon} text-2xl`}></i>
                      </span>
                      <span className="font-heading text-sm text-foreground-400">
                        {String(index + 1).padStart(2, "0")}
                      </span>
                    </div>
                    <h2 className="mt-4 text-xl font-semibold text-foreground-950">
                      <Link to={`/topic/${item.slug}`} className="hover:text-primary-700 transition-colors">
                        {item.name}
                      </Link>
                    </h2>
                    <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                    <Link
                      to={`/topic/${item.slug}`}
                      className="mt-5 inline-flex items-center gap-1.5 text-sm text-foreground-700 hover:text-primary-700 hover:gap-2.5 transition-all"
                    >
                      查看 {list.length} 篇看点 <i className="ri-arrow-right-line"></i>
                    </Link>
                  </div>

                  <div className="lg:col-span-8">
                    {list.length > 0 ? (
                      <ul className="divide-y divide-background-200">
                        {list.slice(0, 3).map((article) => (
                          <li key={article.id} className="py-3 first:pt-0 last:pb-0">
                            <Link to={`/article/${article.id}`} className="group flex items-start gap-3">
                              <i className="ri-file-text-line text-foreground-400 mt-1"></i>
                              <span className="min-w-0">
                                <span className="block text-sm md:text-base text-foreground-900 group-hover:text-primary-700 transition-colors">
                                  {article.title}
                                </span>
                                <span className="mt-1 block text-xs text-foreground-500">
                                  {article.date} · {article.readTime}
                                </span>
                              </span>
                            </Link>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p className="text-sm text-foreground-500">该分类内容正在补充中。</p>
                    )}
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}